jQuery( function($){

    if(!$('.preview').length){
        return;
    }

    var $images = $('.js-preview__slider img');
    var $hovers = $('.js-preview__hover');

    $hovers.on('mouseenter', function(){
        var index = parseInt($(this).data('index'));
        $images.eq(index).addClass('active');
    }).on('mouseleave', function(){
        var index = parseInt($(this).data('index'));
        $images.eq(index).removeClass('active');
    });

});